import { forwardRef, ReactElement, ReactNode } from 'react';

import styled from 'styled-components';

import { Avatar } from '@components/avatar';
import { IconButton as IB } from '@components/icon-button';
import { IconProps } from '@components/icons';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

type ButtonSizeProps = {
  button: string;
  icon: string;
};

export const size: ButtonSizeProps = {
  button: pxToRem(32),
  icon: pxToRem(16),
};

export type Assignee = {
  id: string;
  name: string;
  picture: string;
};

export type AssignButtonProps = {
  assignee: Assignee;
  noAbbreviate?: boolean;
};

export const AssignButton = forwardRef<HTMLDivElement, AssignButtonProps>((props, ref) => {
  const { assignee, noAbbreviate, ...rest } = props;
  return (
    <Avatar
      ref={ref}
      name={assignee.name}
      src={assignee.picture}
      size="lg"
      color="theme"
      border
      noAbbreviate={noAbbreviate}
      {...rest}
    />
  );
});

export type IconButtonProps = {
  icon: ReactElement<IconProps>;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const { icon, ...rest } = props;

  return (
    <StyledIconButton
      ref={ref}
      {...rest}
      icon={<icon.type {...icon.props} size={size.icon} />}
      rounded
      variant="white-purple"
      size="md"
    />
  );
});

const StyledIconButton = styled(IB)({
  borderWidth: pxToRem(2),
  borderStyle: 'solid',
  borderColor: theme.color.border10,
  '&:hover': {
    borderColor: theme.color.border20,
  },
});

export type AssignListProps = {
  children: ReactNode;
};

export const AssignList = (props: AssignListProps) => (
  <Container className="assignee-list" {...props} />
);

AssignList.Avatar = AssignButton;
AssignList.Icon = IconButton;

const Container = styled.div({
  display: 'flex',
  '>*:not(:first-child)': {
    marginLeft: pxToRem(-8),
    zIndex: 0,
  },
});
